import generator from 'generate-password-ts'

export const generatePassword = (): string => {
    const password = generator.generate({
        length: 12,
        numbers: true,
        symbols: true,
        uppercase: true,
        lowercase: true,
        strict: true
    })
    return password
}

export const getImageByCardName = (cardName: string): string => {
    let imageUrl = ''
    switch (cardName) {
        case 'visa':
            imageUrl = '/images/cards/visa.png'
            break
        case 'mastercard':
            imageUrl = '/images/cards/mastercard.png'
            break
        case 'amex':
            imageUrl = '/images/cards/amex.png'
            break
        case 'discover':
            imageUrl = '/images/cards/discover.png'
            break
        case 'diners':
            imageUrl = '/images/cards/diners_club.png'
            break
        case 'jcb':
            imageUrl = '/images/cards/jcb.png'
            break
        case 'unionpay':
            imageUrl = '/images/cards/unionpay.png'
            break
        default:
            imageUrl = '/images/cards/cards.png'
            break
    }
    return imageUrl
}
